import {ArrowDownOutlined, ArrowUpOutlined} from '@ant-design/icons';
import {cn} from '@ds/helpers';

import type {StatCardData} from '../../../../types';

type StatCardProps = {
  data: StatCardData;
};

const StatCard: React.FC<StatCardProps> = ({data}) => {
  const isNegative =
    (data.trend === 'ASC' && data.key !== 'customer_rate') ||
    (data.trend === 'DESC' && data.key === 'customer_rate');

  return (
    <article className="flex min-w-0 flex-1 flex-col gap-2 rounded-lg bg-gray-02 p-2">
      <span className="text-body-sm text-gray-08">{data.title}</span>
      <div className="flex flex-wrap items-center gap-1">
        <span className="text-subtitle-md text-gray-09">{data.value}</span>
        {data.subtitle && <span className="text-subtitle-md text-gray-09">{data.subtitle}</span>}
        {data.trend && (
          <span
            className={cn(
              'flex items-center text-body-sm',
              isNegative ? 'text-destructive' : 'text-success'
            )}
          >
            {data.trend === 'ASC' ? <ArrowUpOutlined aria-hidden /> : <ArrowDownOutlined aria-hidden />}
            {data.changePercentage}%
          </span>
        )}
      </div>
    </article>
  );
};

export default StatCard;
